import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

export default function LegalPage({ docKey }) {
  const { t, lang } = useI18n();
  const doc = t(`legal.${docKey}`);
  const sections = doc.sections || [];

  return (
    <div className="pt-32 pb-24 bg-[#F8F7F4]">
      <div className="mx-auto max-w-[900px] px-5 md:px-8">
        <Link to={`/${lang}`} className="inline-flex items-center gap-2 text-[12px] font-mono uppercase tracking-[0.24em] text-[#5C6B64] hover:text-[#C59B27]" data-testid="legal-back">
          <ArrowLeft className="w-3.5 h-3.5" />
          {t("legal.backHome")}
        </Link>

        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mt-6 font-serif text-4xl sm:text-5xl md:text-6xl text-[#1C352D] leading-[1.02] tracking-tight"
          data-testid={`legal-title-${docKey}`}
        >
          {doc.title}
        </motion.h1>
        <div className="mt-3 text-[11px] font-mono uppercase tracking-[0.24em] text-[#C59B27]">{t("legal.lastUpdated")}</div>

        <p className="mt-8 text-[15px] leading-relaxed text-[#4A5D55]">{doc.intro}</p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-10">
          <aside className="md:col-span-4 md:sticky md:top-24 h-max">
            <div className="text-[10px] font-mono uppercase tracking-[0.28em] text-[#C59B27]">{t("legal.toc")}</div>
            <ol className="mt-4 space-y-2 text-[13px] text-[#4A5D55]">
              {sections.map((s, i) => (
                <li key={i}>
                  <a href={`#sec-${i}`} className="hover:text-[#C59B27]" data-testid={`legal-toc-${i}`}>{s.heading}</a>
                </li>
              ))}
            </ol>
          </aside>

          <div className="md:col-span-8 space-y-10">
            {sections.map((s, i) => (
              <motion.section
                key={i}
                id={`sec-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5 }}
                className="scroll-mt-24"
              >
                <h2 className="font-serif text-2xl text-[#1C352D]">{s.heading}</h2>
                <p className="mt-3 text-[14.5px] leading-relaxed text-[#4A5D55]">{s.body}</p>
              </motion.section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
